import PromoListComponent from '../../promotion/PromoListComponent';

const PomoCustomer = ({ routeBase = "/customer/promotions" }) => {
  return <PromoListComponent route={routeBase} />;
};

export default PomoCustomer;
